// Per-tier capabilities shared by client and server.
// Kept free of any DB / Drizzle dependencies so the client bundle stays small.

export const DOMAIN_LIMITS: Record<string, number> = {
  free: 0,
  starter: 1,
  professional: 2,
  business: 5,
  enterprise: -1, // unlimited
};

export function getDomainLimit(tier: string | null | undefined): number {
  return DOMAIN_LIMITS[tier ?? 'free'] ?? 0;
}

export function canConfigurePagePath(tier: string | null | undefined): boolean {
  return tier === 'enterprise';
}

// Report export (PDF / Word) is available for Professional and above.
export function canExportReport(tier: string | null | undefined): boolean {
  return tier === 'professional' || tier === 'business' || tier === 'enterprise';
}

// Free-tier (and unauthenticated) analyses are limited to the four AI
// discoverability sub-scores (AIO, GEO, AEO, SEO). The deeper foundation
// category breakdowns and prioritized recommendations are reserved for
// paying tiers. Used by both the server (to skip work and persist null
// values) and the client (to gate UI sections + show an upgrade prompt).
export function isMinimalAnalysisTier(tier: string | null | undefined): boolean {
  return !tier || tier === 'free';
}
